import POST_1 from "./post-1";
import POST_2 from "./post-2";
import POST_3 from "./post-3";
import POST_4 from "./post-4";
import POST_5 from "./post-5";

export const BLOG_POSTS = [POST_1, POST_2, POST_3, POST_4, POST_5];

export const getPostBySlug = (slug) => BLOG_POSTS.find((p) => p.slug === slug);

export const SITE = {
  name: "TexasBusinessDispute.com",
  legalEntity: "Prefcap Law",
  city: "Houston",
  state: "Texas",
  attorney: "Reza Chawla",
  // Resolve the canonical base URL at runtime so JSON-LD / canonical tags
  // reflect the actual host (preview vs production) without leaking preview URLs.
  get url() {
    if (typeof window !== "undefined" && window.location?.origin) {
      return window.location.origin;
    }
    return "https://texasbusinessdispute.com";
  },
};
